<div class="flex flex-column gap-inner h-full" [ngClass]="{ spinner: isLoading() }" style="max-height: 300px">
  <div class="overflow-hidden">
    <p-table
      [value]="reportAndEventsValues"
      dataKey="id"
      [scrollable]="true"
      scrollHeight="flex"
      selectionMode="single"
      sortField="localDateTime"
      [sortOrder]="-1">
      <ng-template pTemplate="header">
        <tr>
          <th>Local Time</th>
          <th>Event</th>
          <th>Port</th>
          <th class="text-center">Download</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-report let-rowIndex="rowIndex">
        <tr>
          <td>
            {{ report.localDateTime | date: "yyyy-MM-dd HH:mm" }}
          </td>
          <td class="type type-{{ getSanitizedEventName(report.eventName) }} white-space-nowrap">{{ report.eventName }}</td>
          <td>{{ report.portLoCode }}</td>
          <td *ngIf="!report.id"></td>
          <td *ngIf="report.id" class="relative text-center" [ngClass]="{ spinner: hasActiveDownload(report.id) }">
            <a class="albis-icons-download table-icon-link" disabled="hasActiveDownload(report.id)" (click)="downloadReport(report)"></a>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">No reports available</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
